import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { AuthModule } from 'angular-auth-oidc-client';
import { NavbarComponent } from 'app/core/layout/navbar/navbar.component';
import { FavoritenComponent } from 'app/core/layout/navbar/components/favoriten/favoriten.component';
import { GlobalModule } from 'app/core/services/global/global.module';
import { I18nModule } from 'app/core/services/i18n/i18n.module';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { ClickOutsideModule } from 'app/shared/directives/click-outside/click-outside.module';
import { HasrightModule } from 'app/shared/directives/hasright/hasright.module';
import { CustomWindowModule } from 'app/core/services/custom-window-service/custom-window.module';
import { SidebarNavModule } from './sidebar-nav/sidebar-nav.module';
import { IsLoadingModule } from 'app/shared/directives/is-loading-directive';
import { FocusNearestModule } from 'app/shared/directives/focusNearest/focusNearest.module';
import { BsTabsModule } from 'app/shared/components/bs-tabs/bs-tabs.module';
import { MarkdownDirectiveModule } from 'app/shared/directives/markdown';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HasrightModule,
    TranslateModule,
    I18nModule,
    DialogModule,
    AuthModule,
    GlobalModule,
    WindowModule,
    ClickOutsideModule,
    CustomWindowModule,
    SidebarNavModule,
    IsLoadingModule,
    FocusNearestModule,
    BsTabsModule,
    MarkdownDirectiveModule
  ],
  declarations: [NavbarComponent, FavoritenComponent],
  exports: [NavbarComponent],
})
export class NavbarModule {}
